import * as moment from "moment";

const ZERO_SECONDS = "0 s";

const format = (hours, minutes, seconds) => {
  let result = "";

  if (hours > 0) {
    result += hours + " h ";
  }
  if (minutes > 0) {
    result += minutes + " min ";
  }

  result += seconds + " s";

  return result.trim();
};

/**
 * Take a number of seconds and output human-readable duration string.
 * @param {number | null} seconds
 * @return {string} formatted duration
 */
const formatDuration = (seconds) => {
  if (!seconds) {
    return ZERO_SECONDS;
  }

  const duration = moment.duration(seconds, "seconds");
  return format(duration.hours(), duration.minutes(), duration.seconds());
};

export default formatDuration;
